import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-functie-detail-page',
  templateUrl: './functie-detail-page.component.html'
})
export class FunctieDetailPageComponent implements OnInit, OnDestroy {
  public functieSlug: string;
  public subscription: Subscription;

  public constructor(private route: ActivatedRoute) {}

  public ngOnInit(): void {
    this.subscription = this.route.params.pipe(tap(params => (this.functieSlug = params.slug))).subscribe();
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
